import type { SVGProps } from "react";

export const Media = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      fill="none"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width={16}
      height={16}
      {...props}
    >
      <title id="rhf9AO3xUDqfcYFevoizP-title">Media</title>
      <desc id="rhf9AO3xUDqfcYFevoizP-description">Media blocks</desc>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1 20V4c0-2 2-2 2-2h18s2 0 2 2v16s0 2-2 2H3c-2 0-2-2-2-2zm19 0a1 1 0 001-1V5a1 1 0 00-1-1H4a1 1 0 00-1 1v14a1 1 0 001 1h16z"
        clipRule="evenodd"
      ></path>
      <path
        fill="currentColor"
        d="M15 11.93v.14a.38.38 0 01-.185.325L10.34 15c-.27.16-.41.16-.53.09l-.125-.07a.38.38 0 01-.185-.315v-5.41a.38.38 0 01.185-.325l.125-.07c.12-.07.26-.07.61.135l4.395 2.57a.38.38 0 01.185.325z"
        opacity="0.72"
      ></path>
    </svg>
  );
};
